import store from '@/store';

export default class InternalCallAnswerEvent {
  constructor(body) {
    console.log('[COLLEAGUES] - Chamada em andamento', body);
    const params = {
      from: body.internalCall.from,
      to: body.internalCall.to,
      status: 'answer',
    };

    store.dispatch('colleagues/setInternalCallInProgress', params);
  }
}
